import { styled } from '@linaria/react';

export const HiddenInput = styled.input`
	display: none;
`;
